import { cn } from "@/lib/chillnn/cn";

import { PrintSectionLayout } from "../../layout";

export const EntryFormForGuestOfPrintComposition = () => {
	return (
		<div className="full-view break-inside-avoid-column space-y-2">
			<div className="grid grid-cols-3 gap-3">
				{/* 職業 */}
				<PrintSectionLayout titleChildren={<p className="text-xs">職業(Job)</p>}>
					<div className={cn("rounded-sm border border-solid border-zinc-200", "h-8")} />
				</PrintSectionLayout>

				{/* 国籍 */}
				<PrintSectionLayout titleChildren={<p className="text-xs">国籍(Nationality)</p>}>
					<div className={cn("rounded-sm border border-solid border-zinc-200", "h-8")} />
				</PrintSectionLayout>

				{/* 旅券番号 */}
				<PrintSectionLayout titleChildren={<p className="text-xs">旅券番号(Passport Number)</p>}>
					<div className={cn("rounded-sm border border-solid border-zinc-200", "h-8")} />
				</PrintSectionLayout>
			</div>

			{/* 氏名のサイン */}
			<PrintSectionLayout titleChildren={<p className="text-xs">サイン(Signature)</p>}>
				<div className={cn("rounded-sm border border-solid border-zinc-200", "h-24")} />
			</PrintSectionLayout>
		</div>
	);
};
